<template>
    <div class="add-news-imgList-box">
        <el-form ref="imgListNewsForm" :model="imgListNewsForm" :rules="validateRules" label-width="100px">
            <el-form-item label="标题" prop="newsContentTitle">
                <el-input v-model="imgListNewsForm.newsContentTitle"></el-input>
            </el-form-item>
            <el-form-item label="来源" prop="newsContentSource">
                <el-input v-model="imgListNewsForm.newsContentSource"></el-input>
            </el-form-item>
            <el-form-item label="图片链接1" prop="newsContentImage1">
                <el-input v-model="imgListNewsForm.newsContentImage1"></el-input>
            </el-form-item>
            <el-form-item label="图片链接2" prop="newsContentImage2">
                <el-input v-model="imgListNewsForm.newsContentImage2"></el-input>
            </el-form-item>
            <el-form-item label="图片链接3" prop="newsContentImage3">
                <el-input v-model="imgListNewsForm.newsContentImage3"></el-input>
            </el-form-item>
            <el-form-item label="图片链接4" prop="newsContentImage4">
                <el-input v-model="imgListNewsForm.newsContentImage4"></el-input>
            </el-form-item>
            <el-form-item label="新闻链接" prop="newsContentURL">
                <el-input v-model="imgListNewsForm.newsContentURL"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="createImgListNews('imgListNewsForm')">立即创建</el-button>
                <el-button @click="clearImgListNewsForm">取消</el-button>
            </el-form-item>
        </el-form>
        <div class="preview-box">
            <ImgListComponent :newsData="{newsContentTitle: imgListNewsForm.newsContentTitle, newsContentSource: imgListNewsForm.newsContentSource, newsContentImage: [imgListNewsForm.newsContentImage1, imgListNewsForm.newsContentImage2, imgListNewsForm.newsContentImage3, imgListNewsForm.newsContentImage3], newsContentURL: imgListNewsForm.newsContentURL, newsContentUpdateTime: ''}" :isAd="false"></ImgListComponent>
        </div>
    </div>
</template>
<script>
    import ImgListComponent from '../newsTemplate/ImgList.vue';
    import CONFIG from "@/config/index.js";
    import { mapGetters } from 'vuex';
    export default{
        props: ["specialId", "newsTypeId", "refreshNews"],
        data(){
            return {
                imgListNewsForm: {
                    newsContentTitle: null,
                    newsContentSource: null,
                    newsContentURL: null,
                    newsContentImage1: null,
                    newsContentImage2: null,
                    newsContentImage3: null,
                    newsContentImage4: null
                },
                validateRules: {
                    newsContentTitle: [
                        { required: true, message: '请填写新闻标题', trigger: 'blur' }
                    ],
                    newsContentSource: [
                        { required: true, message: '请填写新闻来源', trigger: 'blur' }
                    ],
                    newsContentImage1: [
                        { required: true, message: '请填写图集第一张图片', trigger: 'blur' }
                    ],
                    newsContentImage2: [
                        { required: true, message: '请填写图集第二张图片', trigger: 'blur' }
                    ],
                    newsContentImage3: [
                        { required: true, message: '请填写图集第三张图片', trigger: 'blur' }
                    ],
                    newsContentImage4: [
                        { required: true, message: '请填写图集第四张图片', trigger: 'blur' }
                    ],
                    newsContentURL: [
                        { required: true, message: '请填写落地链接', trigger: 'blur' }
                    ]
                }
            };
        },
        components: {
            ImgListComponent
        },
        computed: {
            ...mapGetters({
                userInfo: 'getUserInfo'
            })
        },
        methods: {
            createImgListNews(formName){
                let flag = true;
                this.$refs[formName].validate((valid) => {
                    if (!valid) {
                        flag = false;
                        return false;
                    }
                });
                if (!flag) {
                    return;
                }
                this.$http.post(CONFIG.HOST + '/special/addNews', {
                    newsContentTitle: this.imgListNewsForm.newsContentTitle,
                    newsContentCreateUser: this.userInfo.userId,
                    newsContentUpdateUser: this.userInfo.userId,
                    newsTypeId: this.newsTypeId,
                    specialId: this.specialId,
                    newsContentImage: this.imgListNewsForm.newsContentImage1 + ';' + this.imgListNewsForm.newsContentImage2 + ';' + this.imgListNewsForm.newsContentImage3 + ';' + this.imgListNewsForm.newsContentImage4,
                    newsContentURL: this.imgListNewsForm.newsContentURL,
                    newsContentSource: this.imgListNewsForm.newsContentSource,
                    newsContentIsTop: 0
                }).then((response)=>{
                    let result = response.body;
                    if (result && result.status === 1) {
                        this.$notify.success({
                            message: '【营销平台】商业专题-图集创建成功'
                        });
                        this.clearImgListNewsForm();
                        this.refreshNews();
                    } else {
                        
                    }
                }, (response)=>{
                    console.log(response);
                });
            },
            clearImgListNewsForm(){
                for (let key in this.imgListNewsForm) {
                    this.imgListNewsForm[key] = null;
                }
            }
        }
    }
</script>
<style lang="less">
    .add-news-imgList-box{
        .preview-box{
            text-align: left;
            padding-left: 14px;
        }
    }
</style>




// WEBPACK FOOTER //
// ImgList.vue?fa40bbd8